export let AISubcategoryNavItemType = /*#__PURE__*/function (AISubcategoryNavItemType) {
  AISubcategoryNavItemType["AI_FUNDAMENTALS"] = "ai_fundamentals";
  AISubcategoryNavItemType["AI_FOR_PROFESSIONALS"] = "ai_for_professionals";
  AISubcategoryNavItemType["AI_FOR_DEVELOPERS"] = "ai_for_developers";
  AISubcategoryNavItemType["AI_FOR_CREATIVES"] = "ai_for_creatives";
  return AISubcategoryNavItemType;
}({});

// This list is used to fetch the topics for each category.
export const aiTopicIdsByCategory = [{
  slug: AISubcategoryNavItemType.AI_FUNDAMENTALS,
  ids: ['158142', '643646', '158078', '583042']
}, {
  slug: AISubcategoryNavItemType.AI_FOR_PROFESSIONALS,
  ids: ['158002', '536788', '592978', '636452', '157488', '611198', '676309', '723291', '157089', '8028', '30506']
}, {
  slug: AISubcategoryNavItemType.AI_FOR_DEVELOPERS,
  ids: ['2003601', '2004077', '156088', '618008', '2146122', '157089', '8028', '30506']
}, {
  slug: AISubcategoryNavItemType.AI_FOR_CREATIVES,
  ids: ['158100', '158096', '158098', '533350', '157900']
}];

// TODO: This list is used temporarily to display the topics in the categories module.
// Once the topics endpoint is ready, we should use it instead of this list.
export const aiTopicsListsByCategory = {
  'ai-fundamentals': [{
    id: 158142,
    url: '/topic/prompt-engineering',
    name: 'Prompt Engineering'
  }, {
    id: 643646,
    url: '/topic/large-language-models',
    name: 'Top Large Language Models (LLM)'
  }, {
    id: 158078,
    url: '/topic/generative-ai',
    name: 'Generative AI (GenAI)'
  }, {
    id: 583042,
    url: '/topic/ai-agents',
    name: 'AI Agents'
  }],
  'ai-for-professionals': [{
    id: 158002,
    url: '/topic/chatgpt',
    name: 'ChatGPT'
  }, {
    id: 536788,
    url: '/topic/microsoft-copilot',
    name: 'Microsoft Copilot'
  }, {
    id: 592978,
    url: '/topic/google-gemini',
    name: 'Google Gemini (Bard)'
  }, {
    id: 636452,
    url: '/topic/claude-ai',
    name: 'Claude AI'
  }, {
    id: 157488,
    url: '/topic/ai-content-generation',
    name: 'AI Content Generation'
  }, {
    id: 611198,
    url: '/topic/perplexity-ai',
    name: 'Perplexity AI'
  }, {
    id: 676309,
    url: '/topic/agentforce',
    name: 'Agentforce'
  }, {
    id: 723291,
    url: '/topic/deepseek',
    name: 'DeepSeek'
  }],
  'ai-for-developers': [{
    id: 2003601,
    url: '/topic/openai-api',
    name: 'OpenAI API'
  }, {
    id: 2004077,
    url: '/topic/github-copilot',
    name: 'GitHub Copilot'
  }, {
    id: 156088,
    url: '/topic/azure-machine-learning',
    name: 'Azure Machine Learning'
  }, {
    id: 618008,
    url: '/topic/retrieval-augmented-generation',
    name: 'Retrieval Augmented Generation (RAG)'
  }, {
    id: 2146122,
    url: '/topic/langchain',
    name: 'LangChain'
  }, {
    id: 157089,
    url: '/topic/mlops',
    name: 'MLOps'
  }, {
    id: 8028,
    url: '/topic/tensorflow',
    name: 'TensorFlow'
  }, {
    id: 30506,
    url: '/topic/pytorch',
    name: 'PyTorch'
  }],
  'ai-for-creatives': [{
    id: 158100,
    url: '/topic/dalle',
    name: 'DALL·E'
  }, {
    id: 158096,
    url: '/topic/midjourney',
    name: 'Midjourney'
  }, {
    id: 158098,
    url: '/topic/stable-diffusion',
    name: 'Stable Diffusion'
  }, {
    id: 533350,
    url: '/topic/leonardo-ai',
    name: 'Leonardo.Ai'
  }, {
    id: 157900,
    url: '/topic/ai-art',
    name: 'AI Art Generation'
  }]
};
//# sourceMappingURL=constants.js.map